import { Component, computed, effect, inject, input, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerProvider } from '@shared';
import { TooltipDirective } from '@presentation/directives';
import { IconColor, IconComponent, IconMode, IconSize } from '../icon';
import { SpinnerComponent } from '../spinner';

@Component({
  selector: 'cm-action-button',
  standalone: true,
  imports: [
    CommonModule,
    IconComponent,
    SpinnerComponent,
    TooltipDirective,
  ],
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.less',
  host: {
    '[class.cm-disabled]': 'disabled()',
  }
})
export class ActionButtonComponent {
  public readonly iconName = input.required<string>();
  public readonly iconColor = input<IconColor>('primary');
  public readonly iconMode = input<IconMode>('outline');
  public readonly iconSize = input<IconSize | undefined>();
  public readonly ariaLabel = input<string>('');
  public readonly autId = input<string>('');
  public readonly title = input<string>('');
  public readonly disabled = input<boolean>(false);
  public readonly loading = input<boolean>(false);
  public readonly size = input<'md' | 'sm'>('md');
  public readonly color = input<'primary' | 'warning' | 'info' | 'danger'>('primary');

  private readonly _logger = inject(LoggerProvider).createScoped('ActionButton');

  public readonly buttonClasses = computed(() => `size-${this.size()} ${this.color()}`);

  constructor() {
    if (isDevMode()) {
      effect(() => {
        if (!this.ariaLabel().trim() && !this.title().trim()) {
          this._logger.warn(
            `icon "${this.iconName()}" has no accessible name; pass [ariaLabel] (or [title]).`,
          );
        }
      });
    }
  }
}
